//操作员接口
import operatorApi from "@api/operator";
//业务接口
import appApi from "@api/app"
import voucherApi from "@api/voucher"
export default {
  ...operatorApi,
  ...appApi,
  ...voucherApi,
};
